import * as React from 'react';
import { SystemDashboard, SystemHeader } from 'library';
import { ToastContainer } from 'react-toastify';
import { SideBarMenu } from '../SideBarMenu';
import { SideBarPanel } from '../library/dashboard/SideBarPanel';
import { ShowDialogContainer } from '../library/common/ShowDialog';
import { hasReadPermission } from "service/userService";
import { AiOutlineHome, AiOutlineMenu, AiOutlineSecurityScan, AiOutlineBulb, AiOutlineBarChart, AiOutlinePieChart, AiOutlineEnvironment, AiOutlineFileSearch, AiOutlineDatabase } from 'react-icons/ai';
import { withRouter } from 'react-router';
import { Link } from 'react-router-dom';
import MultilevelSidebar from "react-multilevel-sidebar";
import TrailbossFooter  from "./DashboardComponent/footer/footer";

class Layout extends React.PureComponent {
    constructor(props: any) {
        super(props)
        this.state = {
            openCMS: false,
            menuItems: [
                {
                    content: [
                        {
                            id: 1,
                            name: "Home",
                            href: '/dashboard',
                            icon: <AiOutlineHome />,
                            securityObject: hasReadPermission('Top.Opportunity')
                        }
                    ]
                },
                {
                    content: [
                        {
                            id: 2,
                            name: "Opportunity List",
                            href: '/opportunity',
                            icon: <AiOutlineBulb />,
                            securityObject: hasReadPermission('Top.Opportunity')
                        }
                    ]
                },
                {
                    content: [
                        {
                            id: 4,
                            name: "Chart Configuration",
                            href: '/Chart-color',
                            icon: <AiOutlinePieChart />,
                            securityObject: hasReadPermission('Top.ChartColors')
                        }
                    ]
                }, {
                    content: [
                        {
                            id: 4,
                            name: "Dashboard",
                            href: '/opportunitychart',
                            icon: <AiOutlineBarChart />,
                            securityObject: hasReadPermission('Top.Dashboard')
                        }
                    ]
                },
                {
                    content: [
                        {
                            id: 3,
                            name: "Office Locations",
                            href: '/Office-Location',
                            icon: <AiOutlineEnvironment/>,
                            securityObject: hasReadPermission('Top.Locations')
                        }
                    ]
                }, {
                    content: [
                        {
                            id: 2,
                            name: "Lookup Tables",
                            href: '/Lookup',
                            icon: <AiOutlineDatabase />,
                            securityObject: hasReadPermission('Top.Lookup')
                        }
                    ]
                }, //{
                //    content: [
                //        {
                //            id: 2,
                //            name: "Lookup Request",
                //            href: '/Lookup-Request',
                //            icon: <AiOutlineFileSearch />,
                //            securityObject: hasReadPermission('Top.LookupRequest')
                //        }
                //    ]
                //}, 
                {
                    content: [
                        {
                            id: 2,
                            name: "Project Score Card Version",
                            href: '/Project-Score-Card',
                            icon: <AiOutlineHome />,
                            securityObject: hasReadPermission('Top.ScoreCardVersions')
                        }
                    ]
                },
                {
                    content: [
                        {
                            id: 1,
                            name: "Security",
                            href: setting.securityWebUrl,
                            EventTarget: '_blank',
                            icon: <AiOutlineSecurityScan />,
                            securityObject: hasReadPermission('Security'),
                        }
                    ]
                }
            ].filter((item) => { return item.content[0].securityObject == true; })
        };
    }

    handleSidebarCMSToggle = (elem: any) => {
        this.setState({
            openCMS: elem
        })
    };

    handleClick = (itemOptions: any) => {
        if (itemOptions.href) {
            if (itemOptions.EventTarget == '_blank') {
                window.open(itemOptions.href, '_blank');
            } else {
                this.props.history.push({
                    pathname: itemOptions.href
                });
            }
            this.setState({
                openCMS: false
            })
        }
    }

    logoSidebarMenu = () => {
        return (
            <div className="logoDashboardSidebarWrapper">
                <Link to="/dashboard">
                    <img src={setting.cdnUrl + '/assets/images/logo/logo_trailboss.png'} className="logoDashboardSidebar" />
                </Link>
            </div>
        )
    }

    public render() {
        return (
            <>
                <section id="DashboardWrapper">
                    <ToastContainer />
                    <ShowDialogContainer />
                    <div className="DashboardWrapperChild">
                        <div className="sidebarPanel">
                            <div className="logoWrapper">
                                <Link to="/dashboard">
                                    <img src={setting.cdnUrl + '/assets/images/logo/logo_trailboss.png'} className="logoDashboard" />
                                </Link>
                            </div>
                            <div className="menuWrapper">
                                <MultilevelSidebar
                                    open={this.state.openCMS}
                                    onToggle={() => this.handleSidebarCMSToggle()}
                                    options={this.state.menuItems}
                                    header={this.logoSidebarMenu()}
                                    onItemClick={this.handleClick}
                                />
                                <div onClick={() => this.handleSidebarCMSToggle(true)} className="MenuOpenIcon" title="Sidebar Menu">
                                    <AiOutlineMenu size="20" color="#fff" />
                                </div>
                            </div>
                        </div>
                        <React.Fragment>
                            {this.props.children}
                                </React.Fragment>   
                          
                    </div>   
                </section>
                <TrailbossFooter />
            </>
        );
    }
}

export default withRouter(Layout);






